import { AdminDeliveryProposalDetailPage } from "@/pages/admin-delivery-proposal-detail";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth_requeired/admin/delivery-proposals/$id/",
)({
  component: () => {
    const { id } = useParams({ strict: false });
    return <AdminDeliveryProposalDetailPage offerCargoIdStr={id} />;
  },
});
